import axios from 'axios';
import { useHistory } from 'react-router-dom';
import config from '../config';

const api = axios.create({ baseURL: config.apiURL });

let lastPath = '/';

export const useAPI = () => {
  const history = useHistory();

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        if (history.location.pathname !== '/login') {
          history.push(`/login?redirect=${lastPath}`);
          throw new Error(error.response.data);
        } else {
          throw new Error(error.response?.data ?? 'Unable to log in to the requested account.');
        }
      } else {
        throw error;
      }
    }
  );

  return api;
};

// Only to be used where both the auth and router
// contexts are not available.
export const rawAPI = axios.create({ baseURL: config.apiURL });
